import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    hcData: null,
    currentQuestionNumber: null,
    currentSectionNumber: null,
    isFinished: false,
    progressBarPosY: 0
  },
  mutations: {
    hcData(state, data) {
      // We need to add an answer property to each question
      data.sections.forEach(section => {
        section.questions.forEach(question => {
          question.answer = 0;
        });
      });
      data.userData = {};
      data.userData.anti_spam_response = "prevent_bots";
      state.hcData = data;
    },
    /**
     * Move to the next question
     * @param state
     */
    nextQuestion(state) {
      // If no current question, get the first
      if (
        state.currentQuestionNumber === null &&
        state.currentSectionNumber === null
      ) {
        state.currentQuestionNumber = 0;
        state.currentSectionNumber = 0;
      }
      // If we have a current question get the next
      else {
        // If has sibling, move to that
        let numberOfQuestionsInSection =
          state.hcData.sections[state.currentSectionNumber].questions.length;

        if (state.currentQuestionNumber + 1 < numberOfQuestionsInSection) {
          state.currentQuestionNumber++;
        } else if (
          state.currentSectionNumber + 1 ===
          state.hcData.sections.length
        ) {
          // If last section and last question, return false?
          state.currentSectionNumber = false;
          state.currentQuestionNumber = false;
          state.isFinished = true;
        } else {
          // If no next sibling, next section and first question in section
          state.currentQuestionNumber = 0;
          state.currentSectionNumber++;
        }
      }
    },
    /**
     * Move to the previous question
     * @param state
     */
    prevQuestion(state) {
      // If no current question, get the first
      if (
        state.currentQuestionNumber === null &&
        state.currentSectionNumber === null
      ) {
        state.currentQuestionNumber = 0;
        state.currentSectionNumber = 0;
      }
      // If we have a current question get the next
      else {
        // If previous is >= 0, decrement
        if (state.currentQuestionNumber - 1 >= 0) {
          state.currentQuestionNumber--;
        } else if (
          state.currentQuestionNumber - 1 === -1 &&
          state.currentSectionNumber - 1 === -1
        ) {
          state.currentQuestionNumber = 0;
          state.currentSectionNumber = 0;
        } else {
          // If no next sibling, next section and first question in section
          state.currentQuestionNumber =
            state.hcData.sections[state.currentSectionNumber].questions.length -
            1;
          state.currentSectionNumber--;
        }
      }
    },
    /**
     * Set the X position of the progress bar
     * @param state
     */
    setProgressBarPosY(state) {
      setTimeout(() => {
        let currentQuestion = document.querySelector(
          ".questions-panel__question.current .questions-panel__question__inner"
        );
        let currentQuestionBottom = currentQuestion.getBoundingClientRect().top;
        state.progressBarPosY = currentQuestionBottom;
      }, 300);
    }
  },
  getters: {
    hcData: state => {
      return state.hcData;
    },
    currentSectionNumber: state => {
      return state.currentSectionNumber;
    },
    currentQuestionNumber: state => {
      return state.currentQuestionNumber;
    },
    isFinished: state => {
      return state.isFinished;
    },
    progressBarPosY: state => {
      return state.progressBarPosY;
    },
    /**
     * Get the URL of the Health Check endpoint
     * @param state
     * @returns {*}
     */
    apiEndpointUrl: state => {
      return state.hcData.api_root_url + state.hcData.health_check_endpoint_uri;
    }
  },
  actions: {},
  modules: {}
});
